import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OrderHostingComponent from "../../../components/Customer/cards/OrderHostingComponent";

const OrderHostingPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    let redirect = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    return <OrderHostingComponent
        productId={ params.productId }
        billcycle={ params.billcycle }
        shouldRedirect={ (orderId) => redirect(orderId) }
        redirectBack={ () => redirectBack() }
    />;
}

export default OrderHostingPage;